import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { reactI18nextModule } from "react-i18next";
import moment from "moment-with-locales-es6";
import { languages } from "./constants/languages.constants";

let whitelist = languages.map(l => l.value);
let fallbackLng = "en";

const domainDetection = {
    name: "domainDetection",

    lookup(options) {
        // lookup the language via the hostname
        const { location: { hostname } } = window;
        let language;
        whitelist.forEach(lang => {
            if (hostname.startsWith(lang + ".")) {
                language = lang;
            }
        });
        return language;
    },

    cacheUserLanguage(lng, options) {
        // options -> are passed in options
        // lng -> current language, will be called after init and on changeLanguage
        // store it
    }
};
const lngDetection = new LanguageDetector();
lngDetection.addDetector(domainDetection);

i18n.use(Backend).use(lngDetection).use(reactI18nextModule).init({
    detection: {
        order: [
            "domainDetection",
            "querystring",
            "cookie",
            "localStorage",
            "navigator",
            "htmlTag"
        ]
    },
    fallbackLng,

    whitelist,
    // have a common namespace used around the full app
    ns: ["translation"],
    defaultNS: "translation",

    debug: process.env.NODE_ENV !== "production",

    interpolation: {
        escapeValue: false // not needed for react!!
    },

    react: {
        wait: true
    }
}, () => {
    if (i18n.language === "zh") {
        moment.locale("zh_tw");
    } else {
        moment.locale(i18n.language);
    }
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js